import {BackendLeaderboardPlayer, LeaderboardPlayers,} from "./types";

export const toFrontend = (players: BackendLeaderboardPlayer[]) : LeaderboardPlayers[] => {
    return players.map(player => ({
        id: player.userId,
        name: player.userName,
        points: player.totalPoints,
        position: player.currentPosition
    }))
}